import styled from "styled-components";
import { TestimonialsSection } from "../../../../shared/components/speed-recruiting/Testimonials";
import { getTestimonials } from "../../../../shared/lib/api";
import { device } from "../../../../shared/styles/device";
import Layout from "../../components/global/Layout";
import Seo from "../../components/global/Seo";
import { MediaSection } from "../../components/speed-recruiting/Media";
import { ActiveCampaignForm } from "../../components/talentpool/agentur/activecampaignForm";
import { HeroIntroAgenturen } from "../../components/talentpool/agentur/agenturHeroIntro";
import { TagCloud } from "../../components/talentpool/agentur/tagCloud";

const IndexContainer = styled.div`
    &>section {
      margin-bottom: 64px;
    }

    @media ${device.tablet} {
      &>section {
        margin-bottom: 128px;
      }
    }
`;

const TPArbeitgeberPage = ({ testimonials }) => {
  const title = "Deine neuen Mitarbeitenden im Talentpool"
  const description = "Finde junge Talente via Active Sourcing im easyboarding Talentpool für deine Agentur. Jetzt registrieren und Talente entdecken."

  return (
    <>
      <Seo title={title} description={description} />
      <Layout preview={false}>
        <IndexContainer>
          <HeroIntroAgenturen />
          <TagCloud />
          <TestimonialsSection
            headline={<h2>Touristiker*innen sind <span>begeistert</span>.</h2>}
            subheadline={<h3>easyboarding begleitet die Top-Unternehmen der Branche</h3>}
            testmonials={testimonials}
            fullSize={true}
          />
          <ActiveCampaignForm />
          <MediaSection />
        </IndexContainer>
      </Layout>
    </>
  )

}

export default TPArbeitgeberPage;


export async function getStaticProps() {
  const testimonials = await getTestimonials()

  return {
    props: { testimonials },
    revalidate: 120,
  }
}